import { NotifyMeButton } from "@/components/waitlist/NotifyMeButton";
import { Card } from "@/components/ui/card"
import { applications } from "@/data/applications"
import { Button } from "@/components/ui/button"

export function SupplierApps() {
  const dropshippingApps = applications.filter(app => app.type === "dropshipping")

  return (
    <Card className="p-6">
      <h2 className="text-lg font-semibold mb-4">Applications de fournisseurs</h2>
      <div className="grid md:grid-cols-3 gap-4">
        {dropshippingApps.map((app) => (
          <div
            key={app.id}
            className="flex flex-wrap items-center gap-3 p-4 border rounded-lg"
          >
            <app.icon className="h-6 w-6 mr-3 text-muted-foreground" />
            <div>
              <h3 className="font-medium">{app.name}</h3>
              <p className="text-sm text-muted-foreground">{app.description}</p>
            </div>
            <Button variant="outline" disabled>Bientôt disponible</Button>
            <NotifyMeButton channel={app.id} />
          </div>
        ))}
      </div>
    </Card>
  )
}